import { Box, Chip, Text } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../shared/components/variables';

export const RiderDriverInputContainer = styled(Box)`
  && {
    position: relative;

    .MuiAutocomplete-popupIndicator svg {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

    .MuiInputBase-root {
      position: relative;
      z-index: 1;
      max-height: unset !important;
      padding: 0 8px;
      padding-left: 40px;

      input {
        margin-left: 0 !important;
        padding-left: 0 !important;
        min-width: 140px;
      }
    }

    svg.search {
      z-index: 2;
      position: absolute;
      top: 10px;
      left: 10px;
      font-size: 16px;
      color: ${colorPalette.neutral250};
    }

    &.single.hasValue {
      .single-container {
        position: absolute;
        z-index: 2;
        left: 40px;
        top: 4px;
      }
      .MuiInputBase-root {
        input {
          visibility: collapse;
        }
      }
    }
  }
`;

export const RiderDriverChip = styled(Chip)`
  border-color: ${colorTokens.primary.outlineBorder};
  background-color: ${colorTokens.chip.light};
  margin: 4px 0 !important;
  margin-right: 9px !important;

  & > svg {
    color: ${colorTokens.primary.outlineBorder}!important;

    &:first-child {
      display: none !important;
    }
  }

  & > span {
    padding-left: 2px;
  }
`;

export const RiderDriverGroup = styled.div`
  margin: 0 16px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 3px solid ${colorTokens.border.light};

  &:last-child {
    border-bottom: 0;
    padding-bottom: 0;
    margin-bottom: 0;
  }
`;

export const RiderDriverGroupHeader = styled(Text)`
  padding: 8px;
  color: ${colorTokens.text.secondary};
`;

export const RiderDriverListItem = styled(Text)`
  padding-left: 8px;
`;
